<template>
  <div class="content-box">
    <div class="element-box">
      <PedidoRepartoAccionesModalComponent />
      <h5 class="form-header">Lista de Viajes de Reparto</h5>
      <div class="row">
        <div class="col-sm-6">
          <NuevoViajeRepartoModalComponent />
          <br />
        </div>
        <div class="form-inline justify-content-sm-end">
          <input
            class="form-control form-control-sm rounded bright col-5"
            placeholder="Número"
            v-model="filter.numero"
            type="text"
          />
          <div class="col-5">
            <TiendaSelectComponent
              titulo="hide"
              _class="form-control form-control-sm rounded"
              :current="filter"
              @change="filterData()"
            />
          </div>
          <div class="col-2">
            <button class="btn btn-link btn-sm" type="button" v-on:click="filterData">
              <i class="fa fa-search"></i>
            </button>
            <button
              class="btn btn-link btn-sm"
              type="button"
              v-on:click="clearFilterData"
            >
              <i class="fa fa-times"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
    <PedidoRapartoTableComponent :datatabla="data" />
    <PaginationComponent
      :currentPage="currentPage"
      :data="data"
      tipo="MINI"
      @pagechanged="onPageChange"
    />
  </div>
</template>

<script>
import PaginationComponent from "@/components/utils/PaginationComponent";
import NuevoViajeRepartoModalComponent from "@/components/wms/asignar_pedido_reparto/NuevoViajeRepartoModalComponent";
import PedidoRapartoTableComponent from "@/components/wms/asignar_pedido_reparto/PedidoRapartoTableComponent";
import PedidoRepartoAccionesModalComponent from "@/components/wms/asignar_pedido_reparto/PedidoRepartoAccionesModalComponent";
import DynamicService from "@/services/commons/DynamicService";
import TiendaSelectComponent from "@/components/commons/TiendaSelectComponent";

export default {
  components: {
    PaginationComponent,
    NuevoViajeRepartoModalComponent,
    PedidoRapartoTableComponent,
    PedidoRepartoAccionesModalComponent,
    TiendaSelectComponent,
  },
  data() {
    return {
      filtro_ruta: [],
      filter: {},
      current: [],
      mostrarRefresh: false,
      currentPage: 1,
      searchtext: null,
      filterActiva: "",
      data: [],
      rutas: [],
      filtro_estado: "",
    };
  },
  mounted() {
    this.refreshData();
  },
  methods: {
    onPageChange(page) {
      this.currentPage = page;
      this.refreshData({
        page: this.currentPage,
        "filter[search]": this.searchtext,
      });
    },
    filterData() {
      this.refreshData({
        numero: this.filter.numero,
        tienda: this.filter.tienda,
      });
    },
    clearFilterData() {
      delete this.filter.numero;
      this.filter.tienda = "";
      this.refreshData({
        page: 1,
        numero: this.filter.numero,
        tienda: this.filter.tienda,
      });
    },
    hide: function () {
      this.$data.destroy();
    },
    refreshData(params) {
      let self = this;
      DynamicService.fetch("cat", "viajes-reparto", params).then((res) => {
        self.data = res.data;
      });
    },
  },
};
</script>
